import { event as gaEvent } from '@/lib/gtag';

export default function TravelCTA() {
  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stunning%20panoramic%20view%20of%20a%20luxurious%20tropical%20resort%20with%20infinity%20pool%20overlooking%20turquoise%20ocean%2C%20lush%20palm%20trees%20swaying%20gently%2C%20pristine%20white%20sand%20beach%2C%20crystal%20clear%20blue%20water%2C%20golden%20sunset%20sky%20with%20warm%20orange%20and%20pink%20hues%2C%20no%20people%2C%20travel%20destination%20paradise%2C%20cinematic%20wide%20angle%20photography%2C%20vibrant%20colors%2C%20ultra%20high%20quality%20landscape&width=1920&height=900&seq=travel-bg-noperson-v3&orientation=landscape"
          alt="여행을 떠나세요"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/25"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="max-w-2xl">
          <p className="text-[#C9A96E] text-xs tracking-[0.5em] uppercase mb-6 font-light">Save & Travel</p>
          <h2 className="font-serif text-5xl md:text-6xl font-light text-white mb-6 leading-tight">
            촬영 비용 아끼고<br />
            <span className="italic font-normal text-[#C9A96E]">신혼여행을 업그레이드</span><br />
            하세요
          </h2>
          <p className="text-white/80 text-base font-light leading-relaxed mb-8 max-w-xl">
            실제 웨딩 촬영에 쓸 뻔한 <strong className="text-white font-medium">50~180만원</strong>을 아껴서,
            평생 기억에 남을 신혼여행에 투자하세요.
            봄날 AI로 웨딩 사진은 <strong className="text-white font-medium">19,900원</strong>부터 해결하고,
            그 돈으로 유럽·몰디브·일본 어디든 떠나세요.
          </p>

          {/* 절약 계산기 스타일 */}
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-7 mb-10 max-w-lg">
            <p className="text-white/60 text-xs tracking-widest uppercase mb-5 font-light">절약 금액 계산</p>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-white/70 text-sm font-light">실제 웨딩 촬영 평균</span>
                <span className="text-white text-sm font-medium line-through opacity-60">1,000,000원</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-white/70 text-sm font-light">봄날 AI 스탠다드</span>
                <span className="text-[#C9A96E] text-sm font-semibold">39,900원</span>
              </div>
              <div className="h-px bg-white/15 my-2"></div>
              <div className="flex items-center justify-between">
                <span className="text-white font-medium text-sm">절약 금액</span>
                <span className="text-[#C9A96E] text-xl font-serif font-semibold">≈ 960,100원</span>
              </div>
            </div>
          </div>

          {/* 여행지 태그 */}
          <div className="flex flex-wrap gap-2 mb-10">
            {['🗼 파리', '🌊 몰디브', '🌸 일본', '🏝️ 발리', '🏔️ 스위스', '🎡 프라하'].map(dest => (
              <span
                key={dest}
                className="px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white/80 text-sm font-light"
              >
                {dest}
              </span>
            ))}
          </div>

          <a
            href="#pricing"
            onClick={() => gaEvent('click_cta', { location: 'travel_cta', button: 'start_saving' })}
            className="inline-flex items-center gap-2 px-10 py-4 bg-[#C9A96E] text-white text-sm font-medium rounded-full hover:bg-[#b8935a] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-xl hover:scale-105"
          >
            <i className="ri-plane-line text-base"></i>
            지금 절약 시작하기
          </a>
        </div>
      </div>
    </section>
  );
}
